import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Lock, Zap, CreditCard, ArrowRight } from 'lucide-react';
import { CountdownTimer, CTAButton } from './Shared';
export function UrgencySection() {
  return <section className="bg-brand-900 text-white py-12 border-b border-brand-800" data-id="element-141">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-142">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 flex items-center justify-center gap-3" data-id="element-143">
          <span data-id="element-144">⏰</span> EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="flex justify-center mb-4" data-id="element-145">
          <CountdownTimer data-id="element-146" />
        </div>

        <p className="text-brand-200 mb-8" data-id="element-147">
          Después sube $10.000 ARS y no vuelve a bajar.
        </p>

        <div className="bg-brand-950/50 p-6 rounded-2xl border border-brand-800" data-id="element-148">
          <div className="flex justify-between text-sm font-bold mb-2" data-id="element-149">
            <span data-id="element-150">Cupos al precio de lanzamiento:</span>
            <span className="text-amber-400" data-id="element-151">68% tomados</span>
          </div>
          <div className="w-full bg-brand-900 rounded-full h-4 mb-6 overflow-hidden" data-id="element-152">
            <div className="bg-gradient-to-r from-amber-500 to-amber-300 h-4 rounded-full animate-progress" style={{
            width: '68%'
          }} data-id="element-153"></div>
          </div>

          <CTAButton className="w-full" data-id="element-154">→ ASEGURAR MI PRECIO AHORA</CTAButton>
        </div>
      </div>
    </section>;
}
export function PricingSection() {
  return <section id="pricing" className="py-8 md:py-20 bg-slate-50 scroll-mt-10" data-id="element-155">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-156">
        <div className="text-center mb-6 md:mb-16" data-id="element-157">
          <h2 className="text-2xl md:text-5xl font-bold text-slate-900 mb-2 md:mb-4" data-id="element-158">
            Elegí tu Ciudadanía Pack:
          </h2>
          <p className="text-sm md:text-xl text-slate-600" data-id="element-159">
            Todas las opciones incluyen los 6 bonus estratégicos
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-3 md:gap-8 items-center max-w-4xl mx-auto" data-id="element-160">
          {/* Card 2: Featured */}
          <div className="order-2 lg:order-1 bg-white rounded-2xl p-1 border-2 border-amber-400 shadow-2xl relative transform lg:-translate-y-4 z-10" data-id="element-161">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-amber-400 text-slate-900 font-bold px-4 md:px-6 py-1 md:py-1.5 rounded-full text-xs md:text-sm shadow-md whitespace-nowrap" data-id="element-162">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="bg-white rounded-xl p-4 md:p-8 h-full flex flex-col" data-id="element-163">
              <div className="inline-block bg-brand-900 text-white font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-md text-xs md:text-sm mb-2 md:mb-4 self-start" data-id="element-164">
                🏆 PACK COMPLETO
              </div>
              <div className="bg-green-100 text-green-800 text-xs md:text-sm font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-md inline-block self-start mb-3 md:mb-6" data-id="element-165">
                AHORRÁS $7.990
              </div>

              <div className="mb-3 md:mb-6" data-id="element-166">
                <span className="text-slate-400 line-through text-sm md:text-lg block" data-id="element-167">
                  $99.980
                </span>
                <div className="flex items-baseline gap-1" data-id="element-168">
                  <span className="text-3xl md:text-5xl font-black text-slate-900" data-id="element-169">
                    $27.990
                  </span>
                  <span className="text-slate-500 font-medium text-sm md:text-base" data-id="element-170">
                    ARS
                  </span>
                </div>
              </div>

              <ul className="space-y-1.5 md:space-y-4 mb-4 md:mb-8 flex-1 text-xs md:text-base" data-id="element-171">
                {['12 tomos completos', '180 actividades con secuencia', '1° a 3° año secundaria', 'Solucionarios incluidos', '6 Bonus estratégicos', <span key="e1" data-id="element-172">
                    <b data-id="element-173">Planificación Anual</b> lista (Ebook Élite 1)
                  </span>, <span key="e2" data-id="element-174">
                    <b data-id="element-175">Proyectos ESI + EAI</b> listos para firmar (Ebook Élite
                    2)
                  </span>, 'Acceso inmediato PDF'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-176">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-500 shrink-0 mt-0.5" data-id="element-177" />
                    <span className="text-slate-700" data-id="element-178">{item}</span>
                  </li>)}
              </ul>

              <CTAButton className="w-full py-2.5 md:py-4 text-sm md:text-lg mb-2 md:mb-4" data-id="element-179">
                SÍ, QUIERO PACK COMPLETO →
              </CTAButton>

              <div className="hidden md:flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-slate-500 font-medium" data-id="element-180">
                <span className="flex items-center gap-1" data-id="element-181">
                  <Lock className="w-3 h-3" data-id="element-182" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-183">
                  <Zap className="w-3 h-3" data-id="element-184" /> Acceso en 5 min
                </span>
                <span className="flex items-center gap-1" data-id="element-185">
                  <ShieldCheck className="w-3 h-3" data-id="element-186" /> Garantía 7 días
                </span>
                <span className="flex items-center gap-1" data-id="element-187">
                  <CreditCard className="w-3 h-3" data-id="element-188" /> Mercado Pago
                </span>
              </div>
            </div>
          </div>

          {/* Card 3: Secundaria Basic */}
          <div className="order-1 lg:order-2 bg-white rounded-2xl p-4 md:p-8 border border-slate-200 shadow-sm relative" data-id="element-189">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-500" data-id="element-190"></div>
            <div className="inline-block bg-brand-100 text-brand-800 font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-md text-xs md:text-sm mb-3 md:mb-6" data-id="element-191">
              📗 CIUDADANÍA SECUNDARIA
            </div>

            <div className="mb-3 md:mb-6" data-id="element-192">
              <span className="text-slate-400 line-through text-sm md:text-lg block" data-id="element-193">
                $49.990
              </span>
              <div className="flex items-baseline gap-1" data-id="element-194">
                <span className="text-3xl md:text-4xl font-black text-slate-900" data-id="element-195">
                  $18.990
                </span>
                <span className="text-slate-500 font-medium text-sm md:text-base" data-id="element-196">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-1.5 md:space-y-4 mb-4 md:mb-8 text-xs md:text-base" data-id="element-197">
              {['6 tomos completos', '90 actividades con secuencia', '1° a 3° año secundaria', '6 Bonus estratégicos'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-198">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-500 shrink-0 mt-0.5" data-id="element-199" />
                  <span className="text-slate-700" data-id="element-200">{item}</span>
                </li>)}
            </ul>

            <button className="w-full bg-white border-2 border-brand-600 text-brand-600 hover:bg-brand-50 font-bold text-sm md:text-base py-2.5 md:py-3 rounded-xl transition-colors" data-id="element-201">
              → QUIERO SECUNDARIA
            </button>
          </div>
        </div>
      </div>
    </section>;
}
export function PackCompletoDetail() {
  return <section className="py-12 bg-white" data-id="element-202">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-203">
        <div className="bg-brand-900 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden" data-id="element-204">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-800 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3" data-id="element-205"></div>

          <div className="relative z-10" data-id="element-206">
            <div className="inline-block bg-amber-400 text-slate-900 text-xs font-bold px-3 py-1 rounded-full mb-6 uppercase tracking-wider" data-id="element-207">
              LA OPCIÓN MÁS ELEGIDA POR DOCENTES DE SECUNDARIA
            </div>

            <h2 className="text-3xl font-bold mb-8" data-id="element-208">PACK COMPLETO INCLUYE:</h2>

            <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-209">
              {['12 tomos completos', '180 actividades con secuencia', '1° a 3° año secundaria', 'Solucionarios incluidos', '6 Bonus estratégicos', 'Planificación Anual lista (Ebook Élite 1)', 'Proyectos ESI + EAI listos para firmar (Ebook Élite 2)', 'Acceso inmediato PDF'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-210">
                  <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-211" />
                  <span className="font-medium text-slate-100" data-id="element-212">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between gap-6 bg-brand-950/50 p-6 rounded-2xl border border-brand-800" data-id="element-213">
              <div className="text-2xl font-bold" data-id="element-214">Solo por $27.990 ARS</div>
              <CTAButton className="w-full md:w-auto" data-id="element-215">
                → QUIERO MI PACK COMPLETO AHORA
              </CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function GuaranteeSection() {
  return <section className="py-20 bg-slate-50" data-id="element-216">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-217">
        <div className="bg-white border-2 border-slate-200 rounded-3xl p-8 md:p-12 text-center shadow-xl" data-id="element-218">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-219">
            <ShieldCheck className="w-10 h-10 text-green-600" data-id="element-220" />
          </div>

          <div className="inline-block bg-slate-100 text-slate-600 font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-221">
            🛡️ GARANTÍA CIUDADANÍA PACK — 7 DÍAS
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-222">
            Tu inversión está 100% protegida
          </h2>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-12 mb-10 text-lg font-medium text-slate-700" data-id="element-223">
            <div className="flex items-center justify-center gap-2" data-id="element-224">
              <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center font-bold" data-id="element-225">
                1
              </span>
              Abrís los 12 tomos.
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-226">
              <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center font-bold" data-id="element-227">
                2
              </span>
              Revisás los 6 bonus.
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-228">
              <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center font-bold" data-id="element-229">
                3
              </span>
              Los usás en el aula si querés.
            </div>
          </div>

          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 max-w-2xl mx-auto mb-8" data-id="element-230">
            <p className="font-bold text-slate-900 mb-4 text-lg" data-id="element-231">
              Si en 7 días no es lo que esperabas:
            </p>
            <ul className="space-y-2 text-slate-600 text-left max-w-xs mx-auto" data-id="element-232">
              <li className="flex items-center gap-2" data-id="element-233">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-234" /> Te
                devolvemos el 100%.
              </li>
              <li className="flex items-center gap-2" data-id="element-235">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-236" /> Sin
                preguntas.
              </li>
              <li className="flex items-center gap-2" data-id="element-237">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-238" /> Sin
                formularios.
              </li>
              <li className="flex items-center gap-2" data-id="element-239">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-240" /> Sin drama.
              </li>
            </ul>
          </div>

          <p className="text-slate-500 font-medium" data-id="element-241">
            La confianza que tenemos en el Ciudadanía Pack nos permite ofrecerte
            eso.
            <br data-id="element-242" />
            Más de 1.200 docentes ya lo saben.
          </p>
        </div>
      </div>
    </section>;
}
export function ExtendedTestimonials() {
  const testimonials = [{
    avatar: 'PN',
    name: 'Paula N.',
    loc: '📍 Bariloche | Docente de Ciudadanía Secundaria',
    quote: 'Lo bajé un sábado a la tarde y para el lunes ya tenía el primer trimestre cerrado, tomo por tomo y año por año. Las propuestas obligan a los pibes a pensar de verdad, no son para tapar agujeros de hora.'
  }, {
    avatar: 'JM',
    name: 'Julieta M.',
    loc: '📍 San Juan | Docente de Ciudadanía',
    quote: 'Lo que me voló la cabeza fueron el ESI y el EAI ya escritos. Los entregué firmados en la primera reunión y la vice me preguntó si los había mandado a hacer. Le dije que los había trabajado yo. Casi no mentí.'
  }, {
    avatar: 'NF',
    name: 'Nicolás F.',
    loc: '📍 Neuquén | Docente de Ciudadanía',
    quote: 'Lo que me ganó es que está dividido POR AÑO Y POR EJE TEMÁTICO. No tengo que estar adivinando qué le toca a 1°, a 2° o a 3°. Viene todo secuenciado y listo para llevar al aula.'
  }, {
    avatar: 'AM',
    name: 'Agustina M.',
    loc: '📍 Misiones | Docente de Ciudadanía Secundaria',
    quote: 'Pensé que iba a ser otro material genérico bajado de internet. Desde la primera clase me di cuenta que está hecho para la escuela argentina real: cursos de 35 pibes, dos módulos por semana y poco presupuesto.'
  }, {
    avatar: 'GA',
    name: 'Gabriela A.',
    loc: '📍 Mar del Plata | Docente de Ciudadanía',
    quote: 'Mis alumnos de 2° año arrancan a debatir solos apenas pongo el disparador. Los temas del Banco Express son oro puro. Se terminó el silencio incómodo de mirar al techo.'
  }, {
    avatar: 'EH',
    name: 'Esteban H.',
    loc: '📍 Chaco | Docente de Ciudadanía',
    quote: 'Por primera vez en 15 años de aula presenté la planificación anual completa el primer día de marzo. Nunca me había pasado. Me sacó un peso enorme de encima con la parte administrativa.'
  }];
  return <section className="py-20 bg-white" data-id="element-243">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-244">
        <div className="text-center mb-16" data-id="element-245">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-246">
            Lo que dicen los docentes de Ciudadanía que ya tienen su Pack:
          </h2>
          <p className="text-xl text-brand-600 font-medium" data-id="element-247">
            +1.200 docentes de Argentina ya lo usan
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-248">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 p-6 rounded-2xl border border-slate-200 flex flex-col" data-id="element-249">
              <div className="flex gap-1 mb-4" data-id="element-250">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-251" />)}
              </div>
              <p className="text-slate-700 italic mb-6 flex-1" data-id="element-252">"{t.quote}"</p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-200" data-id="element-253">
                <div className="w-10 h-10 bg-brand-100 text-brand-700 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-254">
                  {t.avatar}
                </div>
                <div data-id="element-255">
                  <div className="font-bold text-slate-900 text-sm" data-id="element-256">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-257">{t.loc}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
// Helper icon for ExtendedTestimonials
function StarIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-258">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" data-id="element-259"></path>
      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" fill="currentColor" data-id="element-260"></path>
    </svg>;
}